import { store } from "../store";
import { logout } from "../slices/authSlice";

// Same prefixes the AppSwitcher uses to tell the panels apart. Anything else is Ginox.
const LOGINS = [
  ["/forex-admin", "/forex-admin/login"],
  ["/support-system", "/support-system/login"],
  ["/mining", "/mining/login"],
  ["/web3", "/web3/login"],
];

export const loginFor = (path) =>
  LOGINS.find(([prefix]) => path.startsWith(prefix))?.[1] ?? "/auth/login";

let sent = false;

/**
 * A session API answered 401: the token is dead. Wipe every stored session and land on
 * the login screen of the panel the admin is in. Only the theme survives.
 *
 * Callers must never route a login call through here — the 2FA verify answers 401 when its
 * tempToken lapses, and that has to reach the form as an error, not as a reload.
 */
export function sessionExpired() {
  const base = process.env.PUBLIC_URL || "";
  const path = window.location.pathname.slice(base.length) || "/";
  const login = loginFor(path);
  // Once per page: a dashboard fires several calls and they all 401 together.
  // Already on the login screen: nothing to send anyone to.
  if (sent || path === login) return;
  sent = true;

  // Logout first, so redux-persist's next write is the signed-out state, not the old token.
  store.dispatch(logout());
  const theme = localStorage.getItem("theme");
  localStorage.clear();
  sessionStorage.clear();
  if (theme) localStorage.setItem("theme", theme);
  // A full load, so in-memory state (redux, the mining context) goes too.
  window.location.replace(base + login);
}
